import { WorkflowSummary } from '@opallabs/concepts'

type WorkflowState = {
  approved: boolean
  completedStages?: number
  declinedAssignments?: number
  latestStageType?: 'approval' | 'task' | 'circuit_breaker'
  status?: 'active' | 'complete' | 'inactive' | 'paused'
}

/**
 * Looks at several properties of a workflow to determine
 * what display state we should represent to the user.
 */
export const workflowSummaryFromState = ({
  completedStages = 0,
  declinedAssignments = 0,
  approved,
  latestStageType,
  status,
}: WorkflowState): WorkflowSummary => {
  if (status === 'complete' && approved) {
    return WorkflowSummary.Approved
  }

  if (status === 'complete' && !approved) {
    return WorkflowSummary.TasksComplete
  }

  if (
    status === 'active' &&
    latestStageType === 'approval' &&
    declinedAssignments > 0
  ) {
    return WorkflowSummary.Declined
  }

  if (
    status === 'active' &&
    latestStageType === 'approval' &&
    declinedAssignments === 0
  ) {
    return WorkflowSummary.PendingApproval
  }

  if (status === 'active' && latestStageType === 'task') {
    return WorkflowSummary.PendingTasks
  }

  if (status === 'paused' && completedStages > 1) {
    return WorkflowSummary.Paused
  }

  return WorkflowSummary.NotStarted
}
